module.exports = __webpack_public_path__ + "static/media/summary.ddc6dc06.svg";